import React, { useMemo } from "react";

/**
 * Layered ambient effects: falling sakura petals, drifting gold sparkles,
 * and floating lanterns. CSS-only for performance.
 */
export default function Particles({ active }) {
  const petals = useMemo(
    () =>
      Array.from({ length: 18 }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        duration: 12 + Math.random() * 14,
        delay: Math.random() * -20,
        size: 10 + Math.random() * 14,
        rotate: Math.random() * 360,
        opacity: 0.5 + Math.random() * 0.4,
      })),
    []
  );

  const sparkles = useMemo(
    () =>
      Array.from({ length: 22 }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        duration: 8 + Math.random() * 10,
        delay: Math.random() * -15,
        size: 3 + Math.random() * 4,
      })),
    []
  );

  const lanterns = useMemo(
    () =>
      Array.from({ length: 4 }).map((_, i) => ({
        id: i,
        left: 8 + i * 25 + Math.random() * 8,
        top: 12 + Math.random() * 60,
        duration: 6 + Math.random() * 4,
        delay: Math.random() * -3,
      })),
    []
  );

  if (!active) return null;

  return (
    <div aria-hidden className="fixed inset-0 pointer-events-none z-30 overflow-hidden">
      {/* Sakura petals */}
      {petals.map((p) => (
        <div
          key={`p-${p.id}`}
          className="petal animate-sakura-fall"
          style={{
            left: `${p.left}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            opacity: p.opacity,
            transform: `rotate(${p.rotate}deg)`,
          }}
        />
      ))}

      {/* Gold sparkles drifting up */}
      {sparkles.map((s) => (
        <div
          key={`s-${s.id}`}
          className="sparkle animate-sparkle-drift"
          style={{
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDuration: `${s.duration}s`,
            animationDelay: `${s.delay}s`,
          }}
        />
      ))}

      {/* Floating lanterns */}
      {lanterns.map((l) => (
        <div
          key={`l-${l.id}`}
          className="absolute animate-lantern-float"
          style={{
            left: `${l.left}%`,
            top: `${l.top}%`,
            animationDuration: `${l.duration}s`,
            animationDelay: `${l.delay}s`,
            opacity: 0.55,
          }}
        >
          <svg width="40" height="56" viewBox="0 0 40 56">
            <defs>
              <radialGradient id={`lg-${l.id}`} cx="50%" cy="40%" r="60%">
                <stop offset="0%" stopColor="#FFF4D6" stopOpacity="1" />
                <stop offset="60%" stopColor="#E8D6A8" stopOpacity="0.95" />
                <stop offset="100%" stopColor="#C5A059" stopOpacity="0.7" />
              </radialGradient>
            </defs>
            <line x1="20" y1="0" x2="20" y2="8" stroke="#8a6e3a" strokeWidth="1" />
            <ellipse cx="20" cy="26" rx="16" ry="18" fill={`url(#lg-${l.id})`} stroke="#C5A059" strokeWidth="0.8" />
            <rect x="14" y="44" width="12" height="4" fill="#8a6e3a" rx="1" />
            <line x1="20" y1="48" x2="20" y2="56" stroke="#C5A059" strokeWidth="0.5" />
          </svg>
        </div>
      ))}
    </div>
  );
}
